import emailjs from '@emailjs/browser';

// EmailJS Configuration
const EMAILJS_CONFIG = {
  SERVICE_ID: 'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
  TEMPLATE_ID: 'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
  PUBLIC_KEY: 'YOUR_PUBLIC_KEY' // Replace with your EmailJS public key
};

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

export const sendEmail = async (templateParams) => {
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    );
    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error };
  }
};

// Send signup confirmation email
export const sendSignupEmail = async (userEmail, userName) => {
  const templateParams = {
    to_email: userEmail,
    user_name: userName,
    message: `Welcome to our platform! Your account has been created successfully. Thank you for joining us!`,
    subject: 'Welcome - Account Created Successfully'
  };
  
  return await sendEmail(templateParams);
};

// Send password reset email
export const sendPasswordResetEmail = async (userEmail, resetToken) => {
  const templateParams = {
    to_email: userEmail,
    user_name: 'User',
    message: `You requested a password reset. Your reset code is: ${resetToken}. This code will expire in 10 minutes.`,
    subject: 'Password Reset Request',
    reset_token: resetToken
  };
  
  return await sendEmail(templateParams);
};

export default { sendEmail, sendSignupEmail, sendPasswordResetEmail };